import { KImage, KText } from '@/ui-library/components';
import { Flex, Link } from '@chakra-ui/react';

export const NameCell = (row) => {
  const { contact = {} } = row?.original ?? {};
  const { image_url, first_name, last_name, id } = contact ?? {};
  return (
    <>
      {first_name ? (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - Chakra Link union type
        <Link
          href={`/contacts/${id}`}
          target="_blank"
          w="100%"
          display="flex"
          alignItems="center"
          gap="6px"
        >
          <KImage
            name={`${first_name} ${last_name}`}
            src={image_url}
            backgroundStyles={{ minWidth: '20px', minHeight: '20px' }}
          />
          <KText
            maxW="100%"
            enableTooltip={true}
            isTruncated
            size="sm-regular"
            _hover={{
              textDecoration: 'underline',
              color: 'primary-500',
              cursor: 'pointer',
            }}
            textTransform="capitalize"
          >
            {`${first_name || ' '} ${last_name || ''}`}
          </KText>
        </Link>
      ) : (
        '-'
      )}
    </>
  );
};

export const SourceName = (row) => {
  const { ats_candidate_source = {} } = row?.original?.source ?? {};
  const { name } = ats_candidate_source ?? {};

  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - Chakra Flex union type
    <Flex w="100%">
      <KText maxW="100%" enableTooltip={true} isTruncated size="sm-regular">
        {name || '-'}
      </KText>
    </Flex>
  );
};

export const CreditedTo = (row) => {
  const { credited_to = {} } = row?.original ?? {};
  const { name, avatar } = credited_to ?? {};

  return (
    <>
      {name ? (
        <Flex w="100%" gap="6px">
          <KImage
            name={name}
            src={avatar}
            backgroundStyles={{ minWidth: '20px', minHeight: '20px' }}
          />
          <KText
            maxW="100%"
            enableTooltip={true}
            isTruncated
            size="sm-regular"
            textTransform="capitalize"
          >
            {name}
          </KText>
        </Flex>
      ) : (
        '-'
      )}
    </>
  );
};

export const CreatedBy = (row) => {
  const { created_by } = row?.original ?? {};
  const name =
    typeof created_by === 'object' && created_by?.name
      ? created_by.name
      : typeof created_by === 'string'
        ? created_by
        : '';
  const avatar =
    typeof created_by === 'object' ? created_by?.avatar : undefined;

  return (
    <>
      {name ? (
        <Flex w="100%" alignItems="center" gap="6px">
          <KImage
            name={name}
            src={avatar}
            backgroundStyles={{ minWidth: '20px', minHeight: '20px' }}
          />
          <KText maxW="100%" enableTooltip={true} isTruncated size="sm-regular">
            {name}
          </KText>
        </Flex>
      ) : (
        '-'
      )}
    </>
  );
};
